import React from "react";
import {Layout} from "antd";

const {Footer} = Layout;

const EngageFooter = () => <Footer>Engage ©{new Date().getFullYear()} Modo Cooperative</Footer>;

export default EngageFooter;
